import { styled } from '@acko-tech/building-blocks.ui.common';

export const CardWrapper = styled.div`
    border: ${(props: any) =>
        props.active ? '1px solid #0FA457' : '1px solid #d6d9e0'};
    background: ${(props: any) => props.active && '#EBFBEE'};
    border-radius: 16px;
    padding: 5px 10px;
`;

export const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 112px;
    min-width: 280px;
`;

export const CardContentLeft = styled.div`
    padding-top: 15px;
    min-width: 50%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 20px;
`;

export const CardContentRight = styled.div``;

export const ImageData = styled.img`
    height: 70px;
    object-fit: contain;
    max-height: 70px;
    max-width: 120px;
`;

export const Title = styled.div`
    color: #121212;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;

export const RegNo = styled.div`
    color: #121212;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
`;
export const FuelType = styled.div`
    color: #121212;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

export const ApproxTitle = styled.div`
    font-weight: 400;
    font-size: 12px;
    color: #5b5675;
`;
export const ApproxPrice = styled.div`
    font-weight: 600;
    font-size: 14px;
`;

export const CardBottom = styled.div``;

export const BookArrow = styled.img`
    position: relative;
    top: 2px;
    margin-left: 4px;
`;

export const Edit = styled.div`
    display: flex;
    width: fit-content;
    font-weight: 500;
    font-size: 14px;
    color: #1b73e8;
    padding: 0 10px 10px 0;
    gap: 5px;
    align-items: center;
`;

export const OtherData = styled.div`
    color: #5b5675;
    font-weight: 400;
    font-size: 12px;
    margin-top: -5px;
`;

export const CarDetails = styled.span`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: #4b4b4b;
`;
